import client from '../../client'
import {
  FacilityId,
  Facility,
  FacilityReview,
  SearchResponse,
  ListParams,
  FacilityDetails,
  RecommendedFacility,
  CampaignFacility,
  SearchMetadata,
  SearchCountParams,
  GetCityNameByCodeResponse,
} from './types'
import { PagerParams, ApiResponse, PagerMeta } from '../../types'
import { Timetable } from '../timetables'
import { Program, SearchCountResponse } from '../programs'

export * from './types'

export const list = async (params: ListParams) => {
  const { data, meta }: ApiResponse<Facility[], PagerMeta> = await client.get(
    '/user/facilities',
    {
      params: {
        ...params,
        excludeFullReservations: params.excludeFullReservations ? 1 : 0,
      },
    }
  )
  return { data, meta }
}

export const listOnline = async (params?: ListParams) => {
  const { data, meta }: ApiResponse<Facility[], PagerMeta> = await client.get(
    '/user/facilities/online',
    {
      params: {
        ...params,
        excludeFullReservations: params?.excludeFullReservations ? 1 : 0,
      },
    }
  )
  return { data, meta }
}

export const listRecommended = async () => {
  const { data }: ApiResponse<RecommendedFacility[]> = await client.get(
    '/user/facilities/recommended'
  )
  return data
}

export const listCampaign = async () => {
  const { data }: ApiResponse<CampaignFacility[]> = await client.get(
    '/user/facilities/campaign'
  )
  return data
}

/**
 * @deprecated 施設検索を置き換えたら廃止
 */
export const search = async () => {
  const { data }: ApiResponse<SearchResponse> = await client.get(
    '/user/facilities/search'
  )
  return data
}

export const searchMetadata = async () => {
  const { data }: ApiResponse<SearchMetadata> = await client.get(
    '/user/facilities/meta'
  )
  return data
}

export const searchCount = async (params: SearchCountParams) => {
  const { data }: ApiResponse<SearchCountResponse> = await client.get(
    '/user/facilities/count',
    {
      params: {
        ...params,
        excludeFullReservations: params.excludeFullReservations ? 1 : 0,
      },
    }
  )
  return data
}

export const get = async (id: FacilityId): Promise<FacilityDetails> => {
  const { data }: ApiResponse<FacilityDetails> = await client.get(
    `/user/facilities/${id}`
  )
  return data
}

export const loadMorePrograms = async (id: FacilityId) => {
  const { data }: ApiResponse<Program[]> = await client.get(
    `/user/facilities/${id}/programs`
  )
  return data
}

export const listTimetables = async (id: FacilityId) => {
  const { data }: ApiResponse<Timetable[]> = await client.get(
    `/user/facilities/${id}/timetables`
  )
  return data
}

export const listReviews = (
  id: FacilityId,
  pager?: PagerParams
): Promise<ApiResponse<FacilityReview[], PagerMeta>> =>
  client.get(`/user/facilities/${id}/reviews`, { params: pager })

export const getCityNameByCode = async (cityCode: number) => {
  const { data }: ApiResponse<GetCityNameByCodeResponse> = await client.get(
    `/user/facilities/cityNameByCode/${cityCode}`
  )

  return data
}
